// Abu Dhabi personal trainer hub. Not in the PT hreflang set (en-AE is Dubai).
const content = {
    title: (c) => `Personal Trainer Abu Dhabi from ${c.money(c.lowest, 0)}/Session | At Home`,
    description: (c) =>
        `Certified personal trainers in Abu Dhabi for villas, compounds and island apartments. Packages from ${c.money(c.lowest, 0)} a session; female trainers available.`,
    eyebrow: 'Abu Dhabi',
    h1: 'Personal Trainer in Abu Dhabi',
    heroCopy: (c) =>
        `Train at your villa, compound gym or along the Corniche. ${c.money(c.pt('Signature', 14), 0)} a session, falling to ${c.money(c.lowest, 0)} on longer plans.`,
    image: 'personal-trainer/personal-trainers.jpg',
    imageAlt: 'Personal trainer guiding a client through an exercise',
    facts: ['Villas and compounds', 'Female trainers on request', 'Afternoon slots'],
    packagesTitle: 'Personal training packages in Abu Dhabi',
    packagesIntro: 'Per-session prices fall as packages get longer. Families often share sessions on the partner rate.',
    sections: [
        {
            title: 'How people in Abu Dhabi fit in training',
            cards: [
                { title: 'Early-afternoon sessions', body: 'Many Abu Dhabi workdays finish early. A 3 or 4 pm session at home before the family evening is a popular slot.' },
                { title: 'Villa and compound gyms', body: 'Large homes often have space for a home gym; your trainer can help set one up and programme around it.' },
                { title: 'Winter outdoors', body: 'From November to March: the Corniche promenade, Hudayriyat Island\'s tracks and Yas Marina Circuit\'s community training evenings.' },
                { title: 'Family sessions', body: 'Siblings, spouses or friends training together on the partner rate.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'What Abu Dhabi clients usually come to us for',
            tone: 'muted',
            items: [
                'Losing weight gained over a summer spent mostly indoors.',
                'Getting stronger for padel, football or the cycling track at Yas and Hudayriyat.',
                'Back and neck pain from long daily drives between the island and the mainland.',
                'Rebuilding fitness after a baby, with a female trainer at home.',
                'Keeping older parents mobile and steady on their feet.',
                'A routine the whole family can share in the villa gym.',
            ],
            columns: 2,
        },
        {
            title: 'Island or mainland, the trainer comes to you',
            paragraphs: [
                'Trainers cover Abu Dhabi island, Al Reem, Saadiyat and Yas, and the mainland communities from Khalifa City and Al Raha to Mohammed Bin Zayed City and Al Reef. Sessions run in your home, your building or compound gym, or outdoors in the cooler months - there is no studio to drive to and no membership to pay.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is a personal trainer in Abu Dhabi?',
            answer: (c) => `From ${c.money(c.pt('Signature', 14), 0)} a session on a 14-session package down to ${c.money(c.lowest, 0)} on 50 sessions. Elite trainers cost ${c.money(c.pt('Elite', 50), 0)} to ${c.money(c.pt('Elite', 14), 0)}.`,
        },
        {
            question: 'Do your trainers come to Khalifa City and MBZ?',
            answer: 'Yes - mainland communities as well as the island, Reem, Saadiyat and Yas.',
        },
        {
            question: 'Can I book a female trainer in Abu Dhabi?',
            answer: (c) => `Yes. Female trainer requests add ${c.money(c.mods.female, 0)} a session.`,
        },
    ],
    schema: { name: 'Personal Trainer in Abu Dhabi' },
}

export default content
